import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class KioskService {
	constructor(private http: HttpClient) {}

	getKioskInformation(): Observable<any> {
		return this.http.post<any>(environment.apiUrl + `/get-kiosk-information`, {});
	}
}
